import Injection = EECore.Injection;
import PromotionService from "../../services/promotion/promotionService";
import CurrentPromotion from "../../services/entities/promotion/currentPromotion";
import ProfileReview from "./profileReview";
import PersonalizedAccessCode from "./personalizedAccessCode";
import ElectronicFeatures from "./electronicFeatures";
import SecuredMessaging from "./securedMessaging";

@Injection.injectableClass("Promotion")
export default class Promotion implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("Promotion", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("Promotion", "PromotionService")
  private promotionService: PromotionService;

  @Injection.injectableProperty("Promotion", EECore.Registrations.SESSION)
  private sessionHelper: EECore.Session;

  @Injection.injectableProperty("Promotion", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("Promotion", EECore.Registrations.UNAVAILABLE_SERVICE)
  private unavailableService: EECore.Services.UnavailableService;

  constructor(webComponentFactory: EECore.UI.WebComponentFactory,
    promotionService: PromotionService, sessionHelper: EECore.Session,
    document: Document,
    unavailableService: EECore.Services.UnavailableService) {
    this.webComponentFactory = webComponentFactory;
    this.promotionService = promotionService;
    this.sessionHelper = sessionHelper;
    this.document = document;
    this.unavailableService = unavailableService;
  }

  load(container: Element, culture: string): EECore.Promise<Element, any> | Element {
    if (this.sessionHelper.get("ee-scripts-displayPromotion") === "1") return document.createDocumentFragment() as any;
    this.sessionHelper.set("ee-scripts-displayPromotion", "1");
    return new EECore.Promise<Element, string>((resolve, reject) => {
      this.promotionService.getCurrentPromotion().then((promotion) => {
        this.unavailableService.getAvailabilityservice("EXT2_PROMO").then((availability: EECore.Services.Entities.UnavailableModel) => {
          if (availability.isAvailable === false) {
            // do nothing
          }
          else {
            this.loadPromotion(promotion, container, culture).then(resolve).catch(reject);
          }
        });
      }).catch(() => {
        reject("Could not get the promotion");
      });
    });

  }

  private loadPromotion(currentPromotion: CurrentPromotion, container: Element, culture: string): EECore.Promise<Element, any> {
    let promoterCode = "";
    if (currentPromotion) promoterCode = currentPromotion.promoterCode;
    let promotionComponent: EECore.UI.IWebComponent = null;
    switch (promoterCode) {
      case "PROFILE_REVIEW":
        promotionComponent = this.webComponentFactory.getWebComponent(ProfileReview);
        break;
      case "PERSONALIZED_ACCESS_CODE":
        promotionComponent = this.webComponentFactory.getWebComponent(PersonalizedAccessCode);
        break;
      case "ELECTRONIC_FEATURES":
        promotionComponent = this.webComponentFactory.getWebComponent(ElectronicFeatures);
        break;
      case "SECURED_MESSAGING_PROMOTION":
        promotionComponent = this.webComponentFactory.getWebComponent(SecuredMessaging);
        break;
    }

    if (promotionComponent) {
      (promotionComponent as any).promotionData = currentPromotion;
      return promotionComponent.load(container, culture) as any;
    } else {
      return new EECore.Promise<Element, string>((resolve) => { resolve(this.document.createDocumentFragment() as any); });
    }
  }
}